let policy: any;

export function getTrustedXbrliPolicy(): any | undefined {

  if (policy) return policy;

  if (!(window as any).trustedTypes) return undefined;

  try {
    policy = (window as any).trustedTypes.createPolicy(
      'pki-xbrlInline',
      {
        createHTML: (input: string) => input
      }
    );
  }
  catch {
    // already exists → ignore
  }

  return policy;
}